module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "bet-name"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('system_bet')))])]), _vm._v(" "), _c('div', {
    staticClass: "bet-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bettingSvc.system),
      expression: "bettingSvc.system"
    }, {
      name: "system-bet-validator",
      rawName: "v-system-bet-validator"
    }],
    attrs: {
      "id": "system",
      "type": "number",
      "autocomplete": "off",
      "disabled": _vm.isBettingDisabled
    },
    domProps: {
      "value": (_vm.bettingSvc.system)
    },
    on: {
      "keydown": [_vm.checkChars, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bettingSvc.system = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.bettingSvc.currentNumberOfSystems && _vm.bettingSvc.currentNumberOfSystems > 1) ? _c('label', [_c('span', [_vm._v("/")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bettingSvc.currentNumberOfSystems))])]) : _vm._e(), _vm._v(" "), (!_vm.bettingSvc.currentNumberOfSystems || _vm.bettingSvc.currentNumberOfSystems <= 1) ? _c('label', [_c('span', [_vm._v(_vm._s(_vm._f("translate")('system_no_combinations')))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a35a7942","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/bets/SystemBet.vue
// module id = 407
// module chunks = 0